import { LOCALES, DEFAULT_LANG, langPrefix } from "@/i18n/locales";
import { Warehouse, PawPrint, Tractor, Store, ReceiptText, Gift } from "lucide-react";
import { USECASE_GEN } from "./usecases_gen";

// Use-case ("fonction") SEO landing pages — high-volume keywords, 22 languages.
export const USECASE_KEYS = ["gestion-ferme", "gestion-elevage", "exploitation-agricole", "vente-circuit-court", "facturation", "gratuit"];
export const USECASE_ICON = {
  "gestion-ferme": Warehouse,
  "gestion-elevage": PawPrint,
  "exploitation-agricole": Tractor,
  "vente-circuit-court": Store,
  "facturation": ReceiptText,
  "gratuit": Gift,
};

export function usecaseSlug(key, lang) {
  const m = USECASE_GEN[key] || {};
  return (m[lang] || m[DEFAULT_LANG] || {}).slug;
}

export function usecasePath(key, lang) {
  const slug = usecaseSlug(key, lang);
  return `${langPrefix(lang)}/${slug}`;
}

export function usecaseData(key, lang) {
  const c = USECASE_GEN[key] || {};
  return c[lang] || c[DEFAULT_LANG] || {};
}

export function buildUsecaseAlternates(key, origin) {
  const o = (origin || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");
  const alts = LOCALES.filter((l) => usecaseSlug(key, l.code)).map((l) => ({ hreflang: l.hreflang, href: `${o}${usecasePath(key, l.code)}` }));
  if (usecaseSlug(key, DEFAULT_LANG)) alts.push({ hreflang: "x-default", href: `${o}${usecasePath(key, DEFAULT_LANG)}` });
  return alts;
}

// { key: { lang: slug } } — consumed by the router.
export const USECASE_SLUGS = Object.fromEntries(
  USECASE_KEYS.map((k) => [k, Object.fromEntries(LOCALES.map((l) => [l.code, usecaseSlug(k, l.code)]).filter(([, s]) => s))])
);
